// see MY RESERVATION
// "MAKE A RESERVATION" button


import React from "react";
import { useEffect, useState } from "react";
import { setGoHome, setLoader } from "../../action/homeAction";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getMyActivities } from "../../../action/activityBooking";
import { getDefaultAnalyticsLabel, formatLocalTime, toBool } from "../../JS/utility";
import { CMSPath } from "../../../config/constant";
import { sendAnalytics } from "../../../action/homeAction";
import { closeOrderPopUp } from "../../action/hCommerce2";
import moment from "moment";
import MiniLoader from "../../UI/MiniLoader";
import ActivityBookingCancelPopUp from "./ActivityBookingCancelPopUp";
import { scrollToTop } from "../../../JS/scrollToTop";
import ActivityBookingUpdate from "./ActivityBookingUpdate";
import { formatTime } from "../spaBookingV2/spaBooking2a";
 






function Activities2(props) {
  const { t } = props;
  const [myExistingReservation, setMyExistingReservation] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [updateReservationDetails, setUpdateReservationDetails] = useState(null)
  const [cancelAppointmentId, setCancelAppointmentId] = useState(null)
  const [showCancelReservation, setShowCancelReservation] = useState(false)


  let widgetSesstionId = localStorage.getItem("activityBookingSessionToken");
  let label = getDefaultAnalyticsLabel({
    appVersion: props.installedAppVersion
      ? `${props.installedAppVersion}(${props.installedAppBuildNo})`
      : "",
  });

  const sendTheAnalytics = (isSuccess) => {
    try {

      props.sendAnalytics(
        props.guestDetail,
        props.currentWidgets.widgetType,
        isSuccess ? "FETCH My ACTIVITY RESEVATION - SUCCESS" : "FETCH MY ACTIVITY RESERVATION- FAIL",
        { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": widgetSesstionId },
        0,
        props.guestIsLoggedIn
      );
    } catch (error) {
      return error;
    }

  }

  const formatDate = (dateString) => {
    console.log(dateString, "dateString");
    const reservationDate= dateString.split('T')[0];
    const todayDate = props.serverTimeDate.split("T")[0];

    if( moment(todayDate).format('DD-MM-YYYY') == moment(reservationDate).format('DD-MM-YYYY') ){
      return "Today";
    } else if ( moment(todayDate).subtract(1,'days').format('DD-MM-YYYY') == moment(reservationDate).format('DD-MM-YYYY')) {
      return "Yesterday";
    } else if ( moment(todayDate).add(1,'days').format('DD-MM-YYYY') == moment(reservationDate).format('DD-MM-YYYY')) {
      return "Tomorrow";
    } else {
      return `${moment(dateString).format(props.dateFormat.toUpperCase())}`

    }
  };



  const groupingByDate = (data) => {
    const groupedAccToDay = new Map();

    data.sort((a, b) => {
      return (
        new Date(a.date).getTime() -
        new Date(b.date).getTime()
      );
    });
    console.log(data);
    data.forEach((d) => {
      const groupingKey = formatDate(d.date);
      if (groupedAccToDay.has(groupingKey)) {
        const keyData = groupedAccToDay.get(groupingKey);
        keyData.push(d);
      } else {
        groupedAccToDay.set(groupingKey, [d]);
      }
    });

    console.log(groupedAccToDay, "groupedAccToDay");
    return groupedAccToDay;
  };

  const handleDeleteReservation = (bool, msg) => {
    setShowCancelReservation(false);
    setCancelAppointmentId(null);

    let cachedData = props.cachedApiDataStore["my_reservations"];
    delete cachedData[`my_reservations_${props.bookingData.spaLocationId}`];
    props.setCachedApiDataStore({ ...props.cachedApiDataStore, "my_reservations": cachedData })


    if (bool) {
      props.closeOrderPopUp(true, msg || t('activityBooking.success.cancelMyReservation'), "", false)
    }
    else {
      console.log('would show closeorderpopup now')
      props.closeOrderPopUp(true, msg || t('activityBooking.error.cancelMyReservation'), "", true)
    }
    startFlow();

  }
  const handleUpdateReservation=(bool,msg) => {
    setUpdateReservationDetails(null);

    //delete key ( in cancle ,save , update)
    let cachedData= props.cachedApiDataStore["my_reservations"];
    delete cachedData[`my_reservations_${ props.bookingData.spaLocationId }`];
    props.setCachedApiDataStore({ ...props.cachedApiDataStore,"my_reservations":cachedData})


    if (bool) {
      props.closeOrderPopUp(true, msg ||  t('activityBooking.success.updateMyReservation'), "", false)
    }
    else {
      console.log('would show closeorderpopup now')
      props.closeOrderPopUp(true, msg || t('activityBooking.error.updateMyReservation'), "", true)
    }
    startFlow();
  }


  const fetchMyExistingReservation = () => {

    setShowLoader(true);
    setMyExistingReservation([]);

    //props.bookingData.spaLocationId
    getMyActivities()
      .then((res) => {
        if (res.status == 200 && (res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) {
          let data = res.data.payload.data;
          let activityReservations= data=data.filter(d=>d.type=="activity");


          let locationWiseReservations = {};

          props.cachedApiDataStore["activity_locations"].forEach(location=>{
            locationWiseReservations[`my_reservations_${location.spalocationId}`]=[];
          })
          
          activityReservations.forEach((reservation) => {
            const key = `my_reservations_${reservation.locationId}`
            if (locationWiseReservations.hasOwnProperty(key)) {
              locationWiseReservations[key] = [...locationWiseReservations[key], reservation];
            }
            else {
              locationWiseReservations[key] = [reservation]
            }
          })
          props.setCachedApiDataStore({ ...props.cachedApiDataStore,"my_reservations":locationWiseReservations})

          
 
          setMyExistingReservation(locationWiseReservations[`my_reservations_${props.bookingData.spaLocationId}`]);

          sendTheAnalytics(true)

        } else {

          props.closeOrderPopUp(true,
            res && res.data && res.data.header && res.data.header.status && res.data.header.status.msg || t("activityBooking.error.fetchMyExistingReservation"),
            "", true);
          sendTheAnalytics(false)



        }

      })

      .catch(() => {
        props.closeOrderPopUp(true, t("activityBooking.error.fetchMyExistingReservation"), "", true);

      })

      .finally(() => {
        setShowLoader(false)
      })
  }

  // todo
  const handleGoBack = () => {
    props.handleGoBack()
  }

  const getMyExistingReservation=()=>{
    console.log(props.cachedApiDataStore,"cachedApidata")
    if (props.cachedApiDataStore && props.cachedApiDataStore.hasOwnProperty("my_reservations") && props.cachedApiDataStore["my_reservations"].hasOwnProperty(`my_reservations_${props.bookingData.spaLocationId}`)) {
      setMyExistingReservation(props.cachedApiDataStore["my_reservations"][`my_reservations_${props.bookingData.spaLocationId}`])

    }else{
       fetchMyExistingReservation();

    }
  }

  const startFlow = () => {
    getMyExistingReservation();
    scrollToTop();
  }
  useEffect(() => {
    startFlow();
  }, [])

  return (
    <>
      {
        !updateReservationDetails &&
        <header className="inner-pages w-footer subpages">
            {!showCancelReservation &&
            <a className="button-back" onClick={() => handleGoBack()}></a>

          }
          <div className="heading align-center">
            <div class="splash-brand">
              <img src={`${CMSPath}${props.logo}`} />
            </div>
          </div>
        </header>
      }

      <section className="widgets padding-0 margin-0 container-bg">

        <section class="widgets spa-listing spa-details">



          {!updateReservationDetails &&
            <>
              <div class="widget-header">
                {props.currentWidgetObj.widgetHeaderImageUrl && (
                  <div class="widget-header-img">
                    <img
                      src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                      alt={props.currentWidgetObj.displayName}
                    />
                  </div>
                )}
              <div class="widget-header-title">{props.bookingData.spaName || t("activityBooking.activities")}</div>
                <div class="widget-header-subtitle">
                  {props.bookingData.spaDescribtion}
                </div>
              </div>

              <div class="widgets">
                <div class="gallery-slides itinerary-list">
                  <div class="form-row-heading">
                    {`${t("activityBooking.myReservation")}${myExistingReservation.length > 0 ? "s" : ""
                      }`}
                  </div>

                  {showLoader ? (
                    <MiniLoader />
                  ) : myExistingReservation.length > 0 ? (
                    <>
                      {Array.from(
                        groupingByDate(myExistingReservation).entries()
                      ).map(([day, dataOnThatDay]) => {
                        return (
                          <div class="list-items-container">
                            <div class="list-item-heading">{day}</div>
                            {dataOnThatDay.map((reservation) => {
                              return (
                                <div class="list-item">
                                  <div class="list-item-contents">
                                    <div class="list-item-name">{reservation.lines[0].serviceName}</div>

                                    <div class="list-item-body">
                                      {formatTime(
                                        reservation.date.split('T')[1],
                                        toBool(props.timeFormat)
                                      )}
                                    </div>
                                  </div>

                                  <div class="list-item-opt">
                                    {reservation.cancelled ? (
                                      <span class="status-cancelled">
                                        {'cancelled'}
                                      </span>
                                    ) : (
                                      <>
                                        <button
                                          onClick={() => {
                                            setUpdateReservationDetails(reservation)
                                          }}
                                        >
                                          <i className="fas fa-pen"></i>
                                        </button>
                                        <button
                                          onClick={() => {
                                            console.log("apponitmentId for cancellationg", reservation.id)
                                            setCancelAppointmentId(reservation.id);
                                            setShowCancelReservation(true);
                                          }}
                                        >
                                          <i className="fas fa-times"></i>
                                        </button>
                                      </>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        );
                      })}
                    </>
                  ) : (
                    <div className="no_reservation">
                        {(props.cachedApiDataStore && props.cachedApiDataStore.hasOwnProperty("my_reservations") && props.cachedApiDataStore["my_reservations"].hasOwnProperty(`my_reservations_${props.bookingData.spaLocationId}`)) ? t("activityBooking.no_reservation_found") : t("activityBooking.error.error") }
                    </div>
                  )}
                </div>
              </div>

              <div class="row">
                <div class="form-controls">
                  <button onClick={props.next}>
                    {t("activityBooking.make_a_reservation")}
                  </button>
                </div>
              </div>



              {showCancelReservation && (
                <ActivityBookingCancelPopUp
                  appointmentId={cancelAppointmentId}
                  handleDeleteReservation={handleDeleteReservation}
                  close={() => {
                    setCancelAppointmentId(null);
                    setShowCancelReservation(false);
                  }}
                />
              )}

            </>

          }

          {updateReservationDetails && (
            <ActivityBookingUpdate
              updateReservationDetails={updateReservationDetails}
              handleGoBack={() => {
                setUpdateReservationDetails(null);
              }}
              handleUpdateReservation={handleUpdateReservation}
            />
          )}
        </section>
      </section>
    </>
  )
}
const mapStateToProps = state => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    logo: state.store.home.currentDuration.brandingInfo ?
      state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
    currentHomePage: state.store2.currentHomePage,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    serverTimeDate: state.store.home.serverTimeDate.date,
    dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM,


  }
}

const mapDispatchToProps = { setGoHome, closeOrderPopUp, sendAnalytics }

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation('translations')(Activities2));
